import { Container, Grid, makeStyles, Paper, Typography } from '@material-ui/core'
import React from 'react'
import { CheckboxField } from '../Field/checkbox/CheckboxField'

const useStyles = makeStyles((theme) => ({
    examRow: {
        "& > *": {
            display: "flex"
        },
        // "& h5":{
        //     margin: "0"
        // }
    },
}));

export const ExamenLaboratorioForm = () => {
    const classes = useStyles();
    return (
        <Container>
            <Grid container justifyContent="center">
                <Grid item sm={4} md={4} lg={4} className={classes.examRow} component={Paper}>
                    <Typography variant="h5">
                        Hematológicos
                    </Typography>
                    <CheckboxField label="Hemograma" />
                    <CheckboxField label="Plaquetas" />
                    <CheckboxField label="Plasmodium" />
                    <CheckboxField label="Reticulocitos" />
                    <CheckboxField label="Eritrosedimentación" />
                    <CheckboxField label="Erotis de sangre periferico" />
                    <CheckboxField label="Grupo de Sand. + Factor Rh" />
                    <CheckboxField label="T. de Sangría" />
                    <CheckboxField label="T. de Coagulación" />
                    <CheckboxField label="T. de Protrombina" />
                    <CheckboxField label="T. de Tromboplastina" />
                    <CheckboxField label="Fibrinógeno" />
                    <CheckboxField label="T. de Combs Directa" />
                    <CheckboxField label="T. de Combs Indirecta" />
                    <CheckboxField label="Hemocultivo" />
                    <CheckboxField label="Dimero -D" />
                    <Typography variant="h5">
                        Serológicos
                    </Typography>

                    <CheckboxField label="Widal" />
                    <CheckboxField label="VDRL Cuantitativo" />
                    <CheckboxField label="Test de Lues(VDRL)" />
                    <CheckboxField label="Factor Reumatoide" />
                    <CheckboxField label="P.C. Reactiva(Cuantitativa)" />
                    <CheckboxField label="A.S.T.O. (Cuantitativa)" />
                    <CheckboxField label="Antip. Citrulinado(CCP)" />
                    <Typography variant="h5">
                        Electrolitos
                    </Typography>
                    <CheckboxField label="Sodio" />
                    <CheckboxField label="Potasio" />
                    <CheckboxField label="Cloro" />
                    <CheckboxField label="Calcio" />
                    <CheckboxField label="Fósforo" />
                    <CheckboxField label="Amonio" />
                    <Typography variant="h5">
                        Heces
                    </Typography>
                    <CheckboxField label="Parasitológico" />
                    <CheckboxField label="Sangre oculta" />
                    <CheckboxField label="Moco Fecal" />
                    <CheckboxField label="Cultivo y Antibiograma" />
                    <CheckboxField label="Helicobacter Pylori" />
                    <CheckboxField label="Rotavirus" />
                    <Typography variant="h5">
                        Secreción Vaginal
                    </Typography>
                    <CheckboxField label="Cultivo y Antibiograma" />
                    <CheckboxField label="Ziehl Neelsen" />
                </Grid>
                <Grid item sm={4} md={4} className={classes.examRow} lg={4} component={Paper}>
                    <Typography variant="h5">
                        Bioquímicos
                    </Typography>
                    <CheckboxField label="Glucosa" />
                    <CheckboxField label="Bilirrubina y Fracciones" />
                    <CheckboxField label="Urea" />
                    <CheckboxField label="Creatinina" />
                    <CheckboxField label="Ácido Úrico" />
                    <CheckboxField label="HB. GLicosilada" />
                    <CheckboxField label="Toleranc. de Glucosa(2 horas)" />
                    <CheckboxField label="Triglicéridos" />
                    <CheckboxField label="Colesterol" />
                    <CheckboxField label="H.D.L.- Colesterol" />
                    <CheckboxField label="L.D.L.- COLESTEROL" />
                    <CheckboxField label="Hierro Serico" />
                    <CheckboxField label="Transferina" />
                    <CheckboxField label="Ferritina" />
                    <CheckboxField label="Interleuquina 6(ILS)" />

                    <Typography variant="h5">
                        Enzimas
                    </Typography>
                    <CheckboxField label="Lipasa" />
                    <CheckboxField label="Amilaza" />
                    <CheckboxField label="T.G.O. y T.G.P." />
                    <CheckboxField label="Fosfatasa Alcalina" />
                    <CheckboxField label="Gamma G.T." />
                    <CheckboxField label="Deshidrog. Láctica(L.D.H)" />
                    <CheckboxField label="CPK" />
                    <CheckboxField label="CPK - MB" />
                    <CheckboxField label="Troponina I" />
                    <CheckboxField label="Troponina T" />
                    <CheckboxField label="Prptido Natriuretico TB" />
                    <Typography variant="h5">
                        Orina
                    </Typography>
                    <CheckboxField label="Físico Químico y Sedimento" />
                    <CheckboxField label="Cultivo y Antibiograma" />
                    <CheckboxField label="Microalbuminuria" />
                    <CheckboxField label="Cistina" />
                    <CheckboxField label="Cistina C" />
                    <CheckboxField label="Proteinas Total(24 horas)" />
                    <CheckboxField label="Panel de drogas" />
                    <Typography variant="h5">
                        Esputo
                    </Typography>
                    <CheckboxField label="Gram" />
                    <CheckboxField label="Ziehl Neelsen" />
                    <CheckboxField label="Cultivo y Antibiograma" />
                    


                </Grid>
                <Grid item sm={4} md={4} className={classes.examRow} lg={4} component={Paper}>
                    <Typography variant="h5">
                        Inmunológicos
                    </Typography>
                    <CheckboxField label="H.I.V." />
                    <CheckboxField label="Rubeola A lgM-lgG" />
                    <CheckboxField label="Hepatitis A lgM-lgG" />
                    <CheckboxField label="Hepatitis B (HB+AG)" />
                    <CheckboxField label="H. Pylori lgM-lgG" />
                    <CheckboxField label="Dengue lgM-lgG" />
                    <CheckboxField label="Citomegalovirus lgM-lgG" />
                    <CheckboxField label="Herpes 1 lgM-lgG" />
                    <CheckboxField label="Herpes 2 lgM-lgG" />
                    <CheckboxField label="ToxoPlasma lgM-lgG" />
                    <CheckboxField label="Cistercercus" />
                    <CheckboxField label="Tuberculosis lgM-lgG" />
                    <CheckboxField label="Ant-Antinucleares(ANA)" />
                    <CheckboxField label="Celula LE" />
                    <CheckboxField label="L.E TEST" />
                    <CheckboxField label="Anticoagulante Lupico" />
                    <CheckboxField label="Anti B2 Glicoproteinas 1 - IGA" />
                    <CheckboxField label="IGE" />
                    <CheckboxField label="COVID-19 cualitativo" />
                    <CheckboxField label="COVID-19 cuantitativo" />
                    <Typography variant="h5">
                        Marcadores Tumorales
                    </Typography>

                    <CheckboxField label="Alfafetoproteina" />
                    <CheckboxField label="Carcinoembrionario" />
                    <CheckboxField label="CA 15-3 Mama" />
                    <CheckboxField label="CA 125 Ovario-Utero" />
                    <CheckboxField label="CA 72-4 Tubo digestivo" />
                    <CheckboxField label="CA 21-1 Pulmon" />
                    <CheckboxField label="Enolasa NS-Pulmon" />
                    <CheckboxField label="CA 19-9 Tubo digestivo" />
                    <CheckboxField label="BETA 2 Microglobulina" />
                    <CheckboxField label="PAS Total y Libre Cuantitativo" />
                    <Typography variant="h5">
                        Exudado Faringo
                    </Typography>
                    <CheckboxField label="Cultivo-Antibiograma" />
                    <Typography variant="h5">
                        Hormonas
                    </Typography>
                    <CheckboxField label="T3, T4, TSH" />
                    <CheckboxField label="Prolactina" />
                    <CheckboxField label="FSH" />
                    <CheckboxField label="LH" />
                    <CheckboxField label="Estradiol" />
                    <CheckboxField label="Testosterona" />
                    <CheckboxField label="ACTH" />
                    <CheckboxField label="Cortisol 8 AM" />
                    <CheckboxField label="Cortisol 4 PM" />
                    <CheckboxField label="HCG Beta Cualitativo" />
                    <CheckboxField label="HCG Beta Cuantitativo" />
                    <CheckboxField label="HOMA-IR" />
                    
                </Grid>
            </Grid>
        </Container>
    )
}
